import ContentArea from './ContentArea';
import container from './ContentArea.container';

export default container(ContentArea);
